const capitalRE = /([A-Z])/g;

// jQuery caches the values of data attributes when $(elem).data() is called for
// the first time.  Subsequent calls to $(elem).data() will return the cached value.
// This file implements the same behaviour in our own `getData` function.  We also
// update this cache when setting a data attribute.
const cacheKey = "perseus-data" + Date.now();

export function getData(
    elem: HTMLElement | null,
    name: string,
): string | undefined {
    if (!elem) {
        return undefined;
    }

    if (elem[cacheKey] && name in elem[cacheKey]) {
        return elem[cacheKey][name];
    }

    const attrName = "data-" + name.replace(capitalRE, "-$1").toLowerCase();
    const data = getAttr(elem, attrName);
    if (data) {
        if (!elem[cacheKey]) {
            elem[cacheKey] = {};
        }
        elem[cacheKey][name] = data;
        return data;
    }
    return undefined;
}

export function setData(node: HTMLElement | null, name: string, value: string) {
    if (!node) {
        return;
    }

    const attrName = "data-" + name.replace(capitalRE, "-$1").toLowerCase();
    if (!node[cacheKey]) {
        node[cacheKey] = {};
    }
    node[cacheKey][name] = value;
    return setAttr(node, attrName, value);
}

function getAttr(node: HTMLElement, name: string): string | undefined {
    const result = node.getAttribute(name);
    return result === null ? undefined : result;
}

function setAttr(node: HTMLElement, name: string, value: string) {
    return node.setAttribute(name, value);
}
